import { AxiosInstance } from "axios";

import { authHeader } from "src/api/authHeader";
import { isRefreshUrl, isTaktileRequest } from "src/api/middlewares/utils";
import { refreshSession } from "src/api/refreshSession";
import {
  calculateTokenExpiration,
  getCurrentUnixTimestamp,
} from "src/utils/calculateTokenExpiration";

export const addAuthorizationHeaderMiddleware = (
  axiosInstance: AxiosInstance,
) => {
  return axiosInstance.interceptors.request.use(
    async (config) => {
      const url = [config.baseURL ?? "", config.url ?? ""].join("");

      if (url && isTaktileRequest(url) && !config.headers?.["Authorization"]) {
        // path-only match: the scoped refresh URL carries query params
        const isRefreshRequest = isRefreshUrl(url);
        if (isRefreshRequest) {
          config.headers.set(authHeader(true));
        } else {
          // Check the expiration of the ID token
          const idTokenHeader = authHeader(false);
          if ("Authorization" in idTokenHeader) {
            const tokenExpiry = calculateTokenExpiration(idTokenHeader);
            // If the token is expiring in 1 minute or less, refresh it.
            if (tokenExpiry - getCurrentUnixTimestamp() < 60) {
              await refreshSession();
            }
          }

          config.headers.set(authHeader(false));
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};
